import React from 'react';
import { Link } from 'react-router-dom';
import ajax from '../../utils/ajax';
import dictionary from '../../utils/dictionary';
import functions from '../../utils/functions';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from '../Common/AlertError';
import AlertSuccess from '../Common/AlertSuccess';
import InitialAvatar from '../Common/InitialAvatar';
import SelectSearch from '../Common/SelectSearch';
import TextInput from '../Common/TextInput';

class PopRTJSPayment extends React.Component {

    state = {
        amount:this.props.vehicleInfo.balance.amount*1,
        depositorContact: '',
        depositorName: '',
        souceDescription:'',
        transactionDate:'',
        info: '',
        whiteList:this.props.whiteList,
        bankList:false,
        bankId:false,
        vehicleList:[{'plate_number':this.props.plateNumber, 'balance':this.props.vehicleInfo.balance.amount*1}],
        plateNumber:'',
        searchList:false,
        externalList:true
    }

    componentDidMount() {
      
        this.getBanks()
        if(this.props.listId)
        {
            this.extractVehicleList(this.props.listId)
        }
    }
    

    getBanks=async()=>{
        const server_response=await ajax.getBankingClients();
        if(server_response.status==="OK")
        {
            this.setState({
                bankList:server_response.details.content
            })
        }
    }

    onChangeAmount = (event) => {
        this.setState({ amount: event.target.value })
    }

    onChangeDepositorContact = (event) => {
        this.setState({ depositorContact: event.target.value })
    }

    onChangeDepositorName = (event) => {
        this.setState({ depositorName: event.target.value })
    }

    onChangeBank = (selectedOption) => {
        this.setState({
            bankId: selectedOption.value
        })
    }

    onChangePlateNumber = (event) => {
        this.setState({ plateNumber: event.target.value }, () => this.searchVehicle())
    }

    onChangeSourceDescription =(event)=>{
        this.setState({ souceDescription: event.target.value })

    }

    onChangeTransactionDate =(event)=>{
        this.setState({ transactionDate: event.target.value })

    }
  
  

    onConfirm = async(event) => {
        event.preventDefault();
        const {depositorContact, depositorName, souceDescription, transactionDate, bankId, amount} = this.state
        if (depositorContact.length > 0 && 
            depositorName.length > 0 && 
            souceDescription.length>0 && 
            transactionDate.length>0 && 
            bankId.length>0 &&
            amount>0) {

                const vehicleList = [];
                this.state.vehicleList.map((item, key) =>
                 vehicleList.push(item.plate_number)
                )
                
                
                const server_response = await ajax.depositVehicleRTJS(
                    depositorName,
                    depositorContact,
                    amount,
                    souceDescription,
                    transactionDate,
                    bankId,
                    vehicleList
                )
        
                if (server_response.status === "OK") {
                    //load receipt
                    functions.closePopup("modal_rtjs_payment");
                    this.props.onConfirm(<AlertSuccess message={server_response.details.message} />)
                    // this.setState({
                    //     receipt: <PopPaymentSummary record={server_response.details.content} />
                    // }, () => {
                    //     functions.openPopup("modal_payment_summary");
                    // })
                } else {
                    
                    this.setState({
                        info: <AlertError message={server_response.details.message} />
                    })
                }
            

        } else {
            this.setState({
                info: <AlertError message={dictionary._completeFields} />
            })
            
        }
    }


    

    onClickPlateNumber = (item) => {

        if(item.balance.amount*1==0)
        {
            this.setState({
                info: <AlertError message={item.plate_number + ' ' + ' has no outstanding balance'} />
            })
            return false;
        }
        this.setState({ plateNumber:item.plate_number }, ()=>{
            //get current vehicles
            const vehicleList=this.state.vehicleList
            for(var i=0; i<vehicleList.length; i++)
            {
                if(vehicleList[i].plate_number==item.plate_number)
                {
                    this.setState({
                        info: <AlertError message={item.plate_number + ' ' + ' has already been added'} />
                    })
                    return false;
                }
            }
            vehicleList.push({'plate_number':item.plate_number, 'balance':item.balance.amount*1});
            this.setState({
                vehicleList:vehicleList,
                amount:this.state.amount*1+item.balance.amount*1
            })
        })
    }




    searchVehicle = async () => {
        const server_response = await ajax.searchVehicle(this.state.plateNumber);
        if (server_response.status === "OK") {
            this.setState({
                searchList: server_response.details.content
            })
        } else {
            this.setState({
                searchList: false
            })
        }
    }


    onClickRemovePlate=(item)=>{
        const vehicleList=this.state.vehicleList
        if(item.plate_number==this.props.plateNumber){
            this.setState({
                        info: <AlertError message={"Default vehicle cannot be removed. Please record this cheque using one of the paying vehicles"} />
                    })
            return false;
         }
        for(var i=0; i<vehicleList.length; i++)
        {
            if((vehicleList[i].plate_number==item.plate_number))
            {
                vehicleList.splice(i, 1);
            }
        }
        this.setState({
            vehicleList:vehicleList,
            amount:this.state.amount*1-item.balance
        })

    }



    extractVehicleList=async(list_id)=>{
        this.setState({
            externalList:false
        })
        const server_response = await ajax.extractPaymentVehicleListing(list_id);
        if(server_response.status=="OK")
        {   
            const vehicleList=this.state.vehicleList
            const externalList=server_response.details.content;
            externalList.map((item, key)=>{
                for(var i=0; i<vehicleList.length; i++)
                {
                    if(vehicleList[i].plate_number==item.plate_number)
                    {
                        // this.setState({
                        //     info: <AlertError message={item.plate_number + ' ' + ' has already been added'} />
                        // })
                        return false;
                    }
                }
                vehicleList.push({'plate_number':item.plate_number, 'balance':item.balance.amount*1});
                this.setState({
                    vehicleList:vehicleList,
                    amount:this.state.amount*1+item.balance.amount*1
                })
            })//ends map
        }

        this.setState({
            externalList:true
        })
    }




    render() {

        const bankList = this.state.bankList;
        const optionsBank = [];
        if (bankList && bankList !== "404") {
            bankList.map((item, key) =>
                optionsBank.push({ label: item.bank_name, value: item.bank_id })
            )
        }

        const plateList=this.state.vehicleList;
        const searchList = this.state.searchList;

        return (
            <>
                <div className="modal" id="modal_rtjs_payment">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">


                        <div className="modal-content modal-content-demo shadow">
                            <div className="modal-header">
                                <h6 className="modal-title">New RTGS Payment</h6>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                {this.state.info}
                                <div className="row">

                                <div className="col-4">
                                     <div className="justify-content-center text-center mb-3 d-flex">
                                        <InitialAvatar size={2} value={<i className="fas fa-car"></i>}/>
                                    </div>

                                    <div className="activity-block mr-3 scroll-widget border-top overflow-auto">
										<ul className="task-list">
											
											{plateList.map((item, key)=><li key={key}>
												<i className="task-icon bg-dark"></i>
												<h6>{item.plate_number}<Link to="#" className="float-right text-danger tx-14" onClick={()=>this.onClickRemovePlate(item)}>
                                                        <i className="fas fa-minus-circle"></i>
                                                    </Link>
                                                </h6>
											</li>)}
											
										</ul>
                                        {!this.state.externalList && <ActivityLoader/>}

									</div>




                                </div>



                                <div className="col-8">

                                <div className="justify-content-center text-center mb-3 d-flex">
                                        <InitialAvatar size={2} value={<i className="fas fa-edit"></i>}/>
                                </div>
                                <form method="post" onSubmit={this.onConfirm}>

                                <SelectSearch
                                    label="Select Bank"
                                    onChange={() => this.onChangeBank}
                                    options={optionsBank}
                                    placeholder={"Select Bank of origin..."}
                                />


                                    <TextInput
                                          label="Funds Source"
                                          value={this.state.souceDescription}
                                          type="textarea"
                                          placeholder="Account Number - Account Name"
                                          onChange={() => this.onChangeSourceDescription}
                                    />

                                    <TextInput
                                        label="Amount"
                                        type="number"
                                        onChange={() => this.onChangeAmount}
                                        value={this.state.amount}
                                    />

                                    <TextInput
                                          label="RTGS Date"
                                          value={this.state.transactionDate}
                                          type="date"
                                          onChange={() => this.onChangeTransactionDate}
                                    />
                                     

                                    <TextInput
                                        label="Depositor's Name"
                                        type="text"
                                        onChange={() => this.onChangeDepositorName}
                                        value={this.state.depositorName}
                                    />

                                    <TextInput
                                        label="Depositor's Contact"
                                        type="text"
                                        onChange={() => this.onChangeDepositorContact}
                                        value={this.state.depositorContact}
                                    />

                                <TextInput
                                    label="Add Vehicles"
                                    type="text"
                                    onChange={() => this.onChangePlateNumber}
                                    value={this.state.plateNumber}
                                />

                            {searchList && searchList !== "404" && <div className="btn-list">
                                {searchList.map((item, key) =>
                                    <button key={key}
                                        onClick={() => this.onClickPlateNumber(item)}
                                        type="button"
                                        className="btn ripple btn-light btn-sm">
                                        {item.plate_number}
                                    </button>)}
                            </div>}

                                </form>
                                </div>
                               
                                </div>



                            </div>
                            <div className="modal-footer">
                                <button className="btn ripple btn-success" type="button" onClick={this.onConfirm}>Request RTJS Verification</button>
                                <button className="btn ripple btn-dark" type="button" data-dismiss="modal">Close</button>
                            </div>
                        </div>


                    </div>
                </div>
            </>
        )


    }
}

export default PopRTJSPayment;
